<template>
  <ul class="navbar-nav">
    <li class="nav-item">
      <NavbarDropdown
        :items="items"
        :text="currentLabel"
        :variant="allSelected ? 'warning' : null"
        show-search
        @click:item="onClick"
      />
    </li>
  </ul>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import NavbarDropdown from './NavbarDropdown.vue'

export default {
  name: 'NavbarDivision',

  components: {
    NavbarDropdown,
  },

  data() {
    return {
      search: '',
    }
  },
  computed: {
    ...mapState('zones', {
      divisions: 'countryZones',
      currentDivision: 'currentDivision',
    }),
    currentLabel() {
      return this.currentDivision
        ? this.currentDivision.title || this.$t('divisions.all')
        : this.$t('general.loading')
    },
    currentId() {
      return this.currentDivision ? this.currentDivision.id : null
    },
    allSelected() {
      return !this.currentId
    },
    filteredDivisions() {
      return this.divisions.filter((division) => {
        return (
          division.title.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
        )
      })
    },

    items() {
      const items = this.divisions.map((division) => {
        return {
          id: division.id,
          label: division.title,
          isActive: division.id === this.currentId,
          origin: division,
        }
      })

      items.unshift({
        id: '',
        label: this.$t('divisions.all'),
        isActive: this.allSelected,
        origin: null,
      })

      return items
    },
  },

  methods: {
    ...mapMutations('zones', ['setCurrentDivision', 'setAllDivisions']),

    onClick(item) {
      if (item.origin) {
        this.setCurrentDivision(item.origin)
        return
      }

      return this.setAllDivisions()
    },
  },
}
</script>
